import React from 'react';
import PropTypes from 'prop-types';

const bandLabels = {
  foundational: 'FOUNDATIONAL',
  developing: 'DEVELOPING',
  ready: 'READY',
  excellent: 'EXCELLENT',
};

const bandNarratives = {
  foundational: 'Significant work required to be sale-ready.',
  developing: 'On the path. Several dimensions need attention.',
  ready: 'Sale-ready. Targeted improvements will strengthen position.',
  excellent: 'Highly sale-ready. Maximize value through optimization.',
};

const bandColors = {
  foundational: 'text-red-500',
  developing: 'text-amber-500',
  ready: 'text-[hsl(var(--succeedo-orange))]',
  excellent: 'text-green-500',
};

const ReadinessScoreHeadline = ({ score, band, className }) => {
  const safeBand = bandLabels[band] ? band : 'developing';
  return (
    <div className={`text-center space-y-4 ${className || ''}`}>
      <div>
        <div className="text-[72px] font-light text-[hsl(var(--succeedo-orange))] leading-none mb-2">
          {score}
          <span className="text-[36px] text-[hsl(var(--muted-foreground))] ml-2">/ 100</span>
        </div>
        <div className="flex items-center justify-center gap-2">
          <span className="font-mono text-[11px] uppercase text-[hsl(var(--muted-foreground))] tracking-wide">
            READINESS BAND:
          </span>
          <span
            className={`font-mono text-[11px] uppercase font-semibold tracking-wide ${bandColors[safeBand]}`}>
            {bandLabels[safeBand]}
          </span>
        </div>
      </div>
      <p className="text-[15px] text-[hsl(var(--muted-foreground))] max-w-[500px] mx-auto">
        {bandNarratives[safeBand]}
      </p>
    </div>
  );
};

ReadinessScoreHeadline.propTypes = {
  score: PropTypes.number.isRequired,
  band: PropTypes.oneOf(['foundational', 'developing', 'ready', 'excellent']).isRequired,
  className: PropTypes.string,
};

ReadinessScoreHeadline.defaultProps = {
  className: '',
};

export default ReadinessScoreHeadline;
